export const SPECIAL_COUNTRIES = [
  {
    name: "cyprus",
    countryIso3: "CYP",
    langIso3: "GRC",
  },
  {
    name: "azerbaijan",
    countryIso3: "AZE",
    langIso3: "AZE",
  },
  {
    name: "turkmenistan",
    countryIso3: "TKM",
    langIso3: "RUS",
  },
  {
    name: "uzbekistan",
    countryIso3: "UZB",
    langIso3: "RUS",
  },
  {
    name: "tajikistan",
    countryIso3: "TJK",
    langIso3: "RUS",
  },
  {
    name: "kyrgyzstan",
    countryIso3: "KGZ",
    langIso3: "RUS",
  },
  {
    name: "georgia",
    countryIso3: "GEO",
    langIso3: "ENG",
  },
  {
    name: "malta",
    countryIso3: "MLT",
    langIso3: "ENG",
  },
  {
    name: "albania",
    countryIso3: "ALB",
    langIso3: "ALB",
  },
  {
    name: "serbia-bosnia",
    countryIso3: "BIH",
    langIso3: "SRP",
  },
  {
    name: "croatia-bosnia",
    countryIso3: "BIH",
    langIso3: "HRV",
  },
  {
    name: "kazakhstan",
    countryIso3: "KAZ",
    langIso3: "RUS",
  },
  {
    name: "venezuela",
    countryIso3: "VEN",
    langIso3: "ENG",
  },
  {
    name: "bahrain",
    countryIso3: "BHR",
    langIso3: "ENG",
  },
  {
    name: "panama",
    countryIso3: "PAN",
    langIso3: "ENG"
  },
  {
    name: "lebanon",
    countryIso3: "LBN",
    langIso3: "ENG"
  },
  {
    name: "ethiopia",
    countryIso3: "ETH",
    langIso3: "ENG"
  },
  {
    name: "libya",
    countryIso3: "LBY",
    langIso3: "ENG"
  },
  {
    name: "bangladesh",
    countryIso3: "BGD",
    langIso3: "ENG"
  },
  {
    name: "mauritius",
    countryIso3: "MUS",
    langIso3: "ENG"
  },
  {
    name: "yemen",
    countryIso3: "YEM",
    langIso3: "ENG"
  },
  {
    name: "iraq",
    countryIso3: "IRQ",
    langIso3: "ENG"
  },
  {
    name: "ghana",
    countryIso3: "GHA",
    langIso3: "ENG"
  },
  {
    name: "south-korea",
    countryIso3: "KOR",
    langIso3: "ENG"
  },
  {
    name: "salvador",
    countryIso3: "SLV",
    langIso3: "ENG"
  },
  {
    name: "sierra-leone",
    countryIso3: "SLE",
    langIso3: "ENG"
  },
  {
    name: "algeria",
    countryIso3: "DZA",
    langIso3: "ENG"
  },
  {
    name: "angola",
    countryIso3: "AGO",
    langIso3: "ENG"
  },
  {
    name: "argentina",
    countryIso3: "ARG",
    langIso3: "ENG"
  },
  {
    name: "bolivia",
    countryIso3: "BOL",
    langIso3: "ENG"
  },
  {
    name: "curacao",
    countryIso3: "CUW",
    langIso3: "ENG"
  },
  {
    name: "gambia",
    countryIso3: "GMB",
    langIso3: "ENG"
  },
  {
    name: "honduras",
    countryIso3: "HND",
    langIso3: "ENG"
  },
  {
    name: "israel",
    countryIso3: "ISR",
    langIso3: "ENG"
  },
  {
    name: "maldives",
    countryIso3: "MDV",
    langIso3: "ENG"
  },
  {
    name: "mozambique",
    countryIso3: "MOZ",
    langIso3: "ENG"
  },
  {
    name: "nigeria",
    countryIso3: "NGA",
    langIso3: "ENG"
  },
  {
    name: "paraguay",
    countryIso3: "PRY",
    langIso3: "ENG"
  },
  {
    name: "puerto-rico",
    countryIso3: "PRI",
    langIso3: "ENG"
  },
  {
    name: "qatar",
    countryIso3: "QAT",
    langIso3: "ENG"
  },
  {
    name: "singapore",
    countryIso3: "SGP",
    langIso3: "ENG"
  },
  {
    name: "sri-lanka",
    countryIso3: "LKA",
    langIso3: "ENG"
  },
  {
    name: "trinidad",
    countryIso3: "TTO",
    langIso3: "ENG"
  },
  {
    name: "djibouti",
    countryIso3: "DJI",
    langIso3: "ENG"
  },
  {
    name: "papua-new-guinea",
    countryIso3: "PNG",
    langIso3: "ENG"
  },
  {
    name: "chile",
    countryIso3: "CHL",
    langIso3: "SPA"
  },
  {
    name: "colombia",
    countryIso3: "COL",
    langIso3: "SPA"
  },
  {
    name: "guatemala",
    countryIso3: "GTM",
    langIso3: "SPA"
  },
  {
    name: "peru",
    countryIso3: "PER",
    langIso3: "SPA"
  },
  {
    name: "uruguay",
    countryIso3: "URY",
    langIso3: "SPA"
  },
  {
    name: "oman",
    countryIso3: "OMN",
    langIso3: "ENG"
  },
  {
    name:"kuwait",
    countryIso3:"KWT",
    langIso3: "ENG"
  },
  {
    name:"tanzania",
    countryIso3:"TZA",
    langIso3: "ENG"
  },
  {
    name:"botswana",
    countryIso3:"BWA",
    langIso3: "ENG"
  },
  {
    name:"namibia",
    countryIso3:"NAM",
    langIso3: "ENG"
  },
  {
    name:"zambia",
    countryIso3:"ZMB",
    langIso3: "ENG"
  },
];

export const REGEXP_FOR_SPL_URLS = new RegExp(
  `(${SPECIAL_COUNTRIES.map((country) => country.name).reduce(
    (country, acc) => `${acc}|${country}`
  )})`
);
